import { useState, useEffect, useCallback } from 'react';

const pad = (n) => String(n).padStart(2, '0');
const toISO = (date) => `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;

/**
 * Resmi tatilleri getirir (global). Tüm panellerin takvimlerinde ortak kullanılır.
 * @param {Date} currentDate - görüntülenen ayın tarihi (yıl bazlı çekim için)
 */
export const useHolidays = (currentDate) => {
  const [holidays, setHolidays] = useState([]);
  const year = currentDate instanceof Date ? currentDate.getFullYear() : new Date().getFullYear();

  const loadHolidays = useCallback(async () => {
    try {
      const token = localStorage.getItem('fortis_token');
      const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/calendar/holidays?year=${year}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (res.ok) {
        const data = await res.json();
        setHolidays(data.holidays || []);
      }
    } catch (e) {
      // sessizce geç - tatiller kritik değil
    }
  }, [year]);

  useEffect(() => {
    loadHolidays();
  }, [loadHolidays]);

  const getHolidayForDate = useCallback(
    (date) => {
      if (!(date instanceof Date)) return null;
      const iso = toISO(date);
      return holidays.find((h) => h.date === iso) || null;
    },
    [holidays]
  );

  return { holidays, getHolidayForDate, reloadHolidays: loadHolidays };
};

export default useHolidays;
